/**
 * Prefix sign for a rendered stat. Only adds the "+" a formatted positive number
 * lacks; negatives get "" on purpose — formatNumber already carries the "-", so
 * returning "-" here would double it (e.g. "--12%"). Zero gets no sign.
 */
export const getSign = (value: number | string) => (Number(value) > 0 ? "+" : "");
